<template lang="pug">
div.mylist--overlay(v-show="visibleMyListForm" @click.self="hideForm")
  confirmation-delete-dialog(:visibleDialog="visibleDeleteDialog" :message="confirmationDeleteMessage" @hide-dialog="hideDeleteDialog" @execute-confirmation="executeDeleteConfirmation")
  form.mylist--window(@submit.prevent="onSubmitForm")
    div.mylist--headline
      p.mylist--headline-title マイリストの設定
      p.mylist--headline-lead
        | マイリストを「公開」に設定すると、コメント/メモも含めて他のユーザーが閲覧可能です。
    div.mylist--form
      div.mylist--form-item
        label.mylist--form-label リスト名
        input.mylist--form-value.form-control(v-model="value.name" @input="$emit('input', {...value, name: $event.target.value})" maxlength=50 required)
      div.mylist--form-item
        label.mylist--form-label 説明文
        textarea-autosize.mylist--form-value.form-control(v-model="value.description" :min-height="53" :max-height="113" maxlength="500")
      div.mylist--form-item
        label.mylist--form-label 公開設定
        select.mylist--form-value.form-control(:value="value.published" @input="$emit('input', {...value, published: Number($event.target.value)})")
          option(:value="0")
            | 非公開
          option(:value="1")
            | 公開
      div.mylist--form-item(v-if="value.id")
        label.mylist--form-label 削除
        p.mylist--form-value
          span.mylist--form-delete(@click="showDeleteDialog") <i class="fa fa-trash font-awesome-icon"></i>このマイリストを削除する
      div.mylist--form-submit
        template(v-if="value.id")
          button.mylist--form-update(@click="onSubmitForm")
            | 更新する
        template(v-else)
          button.mylist--form-update(type="submit")
            | 作成する
</template>

<script>
import ConfirmationDeleteDialog from 'components/common/confirmation_dialog.vue';

export default {
  components: { ConfirmationDeleteDialog },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    visibleMyListForm: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      visibleDeleteDialog: false,
      confirmationDeleteMessage: 'この操作は取り消せません。本当に削除してよろしいですか？'
    };
  },
  methods: {
    hideForm: function() {
      this.$emit('hide-my-list-form');
      this.hideDeleteDialog;
    },
    onSubmitForm: function() {
      this.$emit('on-submit-form');
    },
    showDeleteDialog: function() {
      this.visibleDeleteDialog = true;
    },
    hideDeleteDialog: function() {
      this.visibleDeleteDialog = false;
    },
    executeDeleteConfirmation: function() {
      this.$emit('destroy-my-list', this.value.id);
    }
  }
};
</script>
